export const IMAGES = {
  heroTea:
    "https://images.unsplash.com/photo-1764173039543-f9f197744e1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxoYXBweSUyMHNlbmlvciUyMGNvbXBhbmlvbiUyMHdhcm0lMjB0ZWElMjBjb252ZXJzYXRpb24lMjB3YWxrfGVufDB8fHx8MTc5MTA2OTc4M3ww&ixlib=rb-4.1.0&q=85",
  aboutWalk:
    "https://images.unsplash.com/photo-1789349073347-eda8249a68a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxzZW5pb3IlMjBjb3VwbGUlMjB3YWxraW5nJTIwbmF0dXJlJTIwbW91bnRhaW5zJTIwcGF0aCUyMHN1bnNldHxlbnwwfHx8fDE3OTEwOTA4NTh8MA&ixlib=rb-4.1.0&q=85",
  servicesBench:
    "https://images.unsplash.com/photo-1706806594789-4cc731ded0e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxoYXBweSUyMHNlbmlvciUyMGNvbXBhbmlvbiUyMHdhcm0lMjB0ZWElMjBjb252ZXJzYXRpb24lMjB3YWxrfGVufDB8fHx8MTc5MTA2OTc4M3ww&ixlib=rb-4.1.0&q=85",
  testimonialPortrait:
    "https://images.unsplash.com/photo-1603129473525-4cd6f36fe057?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxzZW5pb3IlMjBwZW9wbGUlMjBoYXBwaW5lc3N8ZW58MHx8fHwxNzkxMDY5NzkzfDA&ixlib=rb-4.1.0&q=85",
  communityLaugh:
    "https://images.unsplash.com/photo-1575267685970-7fbabf6ed7b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxzZW5pb3IlMjBwZW9wbGUlMjBoYXBwaW5lc3N8ZW58MHx8fHwxNzkxMDY5NzkzfDA&ixlib=rb-4.1.0&q=85",
};

export const PHONE = "(403) 993-7501";
export const PHONE_HREF = "tel:+14039937501";
export const EMAIL = "info@offourrockersseniorscare.ca";
export const EMAIL_HREF = `mailto:${EMAIL}`;
export const BBB_URL =
  "https://www.bbb.org/ca/ab/calgary/profile/senior-care/off-our-rockers-seniors-care-0017-128790/";
export const BBB_SEAL = "https://seal-calgary.bbb.org/logo/ruhzbum/bbb-128790.png";
export const SERVICE_AREA = "Calgary, Alberta & surrounding areas";
export const VISIT_TIMES = "Flexible — days, evenings & weekends";
